import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

import { OtpEmpresaCandidata } from 'src/app/core/models/otp.model';

/**
 * Painel de escolha de empresa do fluxo OTP — sub-estado do Passo 1, ANTES
 * do código (`ux.md` §3.3/§5.12, spec `§4.6`/`§5.1-B`).
 *
 * NÃO é `EmpresaSelecaoComponent` nem o substitui — aquele componente
 * continua existindo e em uso pelo login, com rótulo de razão social
 * (`empresas[].nome`) e gatilho `409 EMPRESA_AMBIGUA`. Este componente é
 * novo e específico do OTP porque o conteúdo é outro por desenho (M-1):
 * - rótulo é `destinoMascarado` (e-mail mascarado), não razão social;
 * - ícone de envelope, não de prédio — o rótulo é um destino de e-mail;
 * - `nome` só aparece como texto auxiliar no desempate de máscaras
 *   colididas — o componente não decide isso, só renderiza o que vier;
 * - escolher dispara loading NO ITEM clicado (a chamada gera e envia o
 *   código — não é instantâneo), não no botão "Confirmar" (não existe).
 */
@Component({
  standalone: true,
  selector: 'app-otp-empresa-selecao',
  templateUrl: './otp-empresa-selecao.component.html',
  styleUrls: ['./otp-empresa-selecao.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonModule]
})
export class OtpEmpresaSelecaoComponent {
  @Input() empresas: readonly OtpEmpresaCandidata[] = [];
  /** `ref` do item em que o loading do clique está ativo (ou `null`). */
  @Input() loadingRef: string | null = null;
  @Input() errorMessage = '';

  @Output() escolher = new EventEmitter<string>();
  @Output() voltar = new EventEmitter<void>();

  onEscolher(ref: string): void {
    if (this.loadingRef) return;
    this.escolher.emit(ref);
  }

  onVoltar(): void {
    if (this.loadingRef) return;
    this.voltar.emit();
  }
}
